var _style, _path, _path2, _path3, _g, _path4, _g2, _line, _g3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 841.89 595.28"
    },
    xmlSpace: "preserve",
    viewBox: "346.21 144.41 154.46 257.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st4{fill:#010101;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.18,146.72c-3.75,24.67-9.8,44.45-14.96,58.5c-10.93,29.78-19.97,39.51-26.75,44.21  c-6.78-4.69-15.82-14.42-26.76-44.21c-5.06-13.78-10.97-33.06-14.74-57.06c10.94,3.69,24.7,5.9,39.63,5.9  C439.38,154.06,454.69,151.27,466.18,146.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.18,155.59c-3.75,24.67-9.8,44.45-14.96,58.5c-10.93,29.78-19.97,39.51-26.75,44.21  c-6.78-4.69-15.82-14.42-26.76-44.21c-5.06-13.78-10.97-33.06-14.74-57.06c10.94,3.69,24.7,5.9,39.63,5.9  C439.38,162.93,454.69,160.14,466.18,155.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.95,251.8l2.95,1.35c3.1-4.15,1.05-6.68,1.84-15.12c0.58-6.1-0.83-13.48-1.27-15.43  c-2.58-11.78-4.25-32.93-8.55-63.93l-0.21,0.02l5.24,69.74V251.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M356.47,222.61c0.44,1.95,1.85,9.32,1.27,15.43c-0.8,8.43-3.37,13.24-6.48,17.4   c-0.75,1.02-1.72,2.22-1.72,2.22c-0.35,0.43-0.49,1.21-0.32,1.73c0,0,6.3,19.28,7.24,34.42c0.65,10.38-0.23,17.79-1.21,27.21   c-1.32,12.64-4.46,53.72-4.46,53.72c-0.04,0.55,0.33,1.19,0.83,1.42l50.79,23.64c0.5,0.23,1.18,0.07,1.52-0.37   c0,0,9.39-12.1,20.25-18.56c9.73-5.79,23.51-8.57,23.51-8.57c0.54-0.11,0.98-0.65,0.97-1.2l-0.6-112.28c0-0.55-0.45-1.06-1-1.14   c0,0-13.04-1.85-21.38-6.81c-6.97-4.14-16.82-12.41-29.02-45.66c-5.23-14.25-14.91-58.58-14.91-58.58   c-0.12-0.54-0.64-0.84-1.17-0.67l-31.95,10.88c-0.52,0.17-0.89,0.75-0.81,1.29c0,0,0,0.03,0.07,0.53   C352.22,189.67,353.89,210.82,356.47,222.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M356.47,222.61c0.44,1.95,1.85,9.32,1.27,15.43c-0.8,8.43-3.37,13.24-6.48,17.4   c-0.75,1.02-1.72,2.22-1.72,2.22c-0.35,0.43-0.49,1.21-0.32,1.73c0,0,6.3,19.28,7.24,34.42c0.65,10.38-0.23,17.79-1.21,27.21   c-1.32,12.64-4.46,53.72-4.46,53.72c-0.04,0.55,0.33,1.19,0.83,1.42l50.79,23.64c0.5,0.23,1.18,0.07,1.52-0.37   c0,0,9.39-12.1,20.25-18.56c9.73-5.79,23.51-8.57,23.51-8.57c0.54-0.11,0.98-0.65,0.97-1.2l-0.6-112.28c0-0.55-0.45-1.06-1-1.14   c0,0-13.04-1.85-21.38-6.81c-6.97-4.14-16.82-12.41-29.02-45.66c-5.23-14.25-14.91-58.58-14.91-58.58   c-0.12-0.54-0.64-0.84-1.17-0.67l-31.95,10.88c-0.52,0.17-0.89,0.75-0.81,1.29c0,0,0,0.03,0.07,0.53   C352.22,189.67,353.89,210.82,356.47,222.61z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.93,251.8l-1.54-2.75c-3.1-4.15-2.45-2.59-3.25-11.02c-0.58-6.1,0.83-13.48,1.27-15.43  c2.58-11.78,4.25-32.93,8.55-63.93l0.21,0.02l-5.24,69.74V251.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M490.41,223.29c-0.44,1.95-1.85,9.32-1.27,15.43c0.8,8.43,3.37,13.24,6.48,17.4c0.75,1.02,1.72,2.22,1.72,2.22   c0.35,0.43,0.49,1.21,0.32,1.73c0,0-6.3,19.28-7.24,34.42c-0.65,10.38,0.23,17.79,1.21,27.21c1.32,12.64,4.46,53.72,4.46,53.72   c0.04,0.55-0.33,1.19-0.83,1.42l-50.79,23.64c-0.5,0.23-1.18,0.07-1.52-0.37c0,0-9.39-12.1-20.25-18.56   c-9.73-5.79-23.51-8.57-23.51-8.57c-0.54-0.11-0.98-0.65-0.97-1.2l0.6-112.28c0-0.55,0.45-1.06,1-1.14c0,0,13.04-1.85,21.38-6.81   c6.97-4.14,16.82-12.41,29.02-45.66c5.23-14.25,14.91-58.58,14.91-58.58c0.12-0.54,0.64-0.84,1.17-0.67l31.95,10.88   c0.52,0.17,0.89,0.75,0.81,1.29c0,0,0,0.03-0.07,0.53C494.66,190.36,493,211.51,490.41,223.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490.41,223.29c-0.44,1.95-1.85,9.32-1.27,15.43c0.8,8.43,3.37,13.24,6.48,17.4c0.75,1.02,1.72,2.22,1.72,2.22   c0.35,0.43,0.49,1.21,0.32,1.73c0,0-6.3,19.28-7.24,34.42c-0.65,10.38,0.23,17.79,1.21,27.21c1.32,12.64,4.46,53.72,4.46,53.72   c0.04,0.55-0.33,1.19-0.83,1.42l-50.79,23.64c-0.5,0.23-1.18,0.07-1.52-0.37c0,0-9.39-12.1-20.25-18.56   c-9.73-5.79-23.51-8.57-23.51-8.57c-0.54-0.11-0.98-0.65-0.97-1.2l0.6-112.28c0-0.55,0.45-1.06,1-1.14c0,0,13.04-1.85,21.38-6.81   c6.97-4.14,16.82-12.41,29.02-45.66c5.23-14.25,14.91-58.58,14.91-58.58c0.12-0.54,0.64-0.84,1.17-0.67l31.95,10.88   c0.52,0.17,0.89,0.75,0.81,1.29c0,0,0,0.03-0.07,0.53C494.66,190.36,493,211.51,490.41,223.29z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 422.61,
    y1: 162.93,
    x2: 423.66,
    y2: 248.71
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 352.8,
    y: 339.88,
    className: "st0",
    width: 36.28,
    height: 2.82
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.59,
    y: 339.88,
    className: "st0",
    width: 36.28,
    height: 2.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 376.98,
    y1: 286.87,
    x2: 378.19,
    y2: 338.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 468.95,
    y1: 288.29,
    x2: 467.74,
    y2: 339.88
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 407.08,
    cy: 267.48,
    r: 5.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 407.77,
    cy: 315.59,
    r: 5.12
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 407.08,
    cy: 363.71,
    r: 5.12
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 442.57,
    cy: 267.48,
    r: 5.12
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 443.25,
    cy: 315.59,
    r: 5.12
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 442.57,
    cy: 363.71,
    r: 5.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVest);
export default __webpack_public_path__ + "static/media/vest.48eb56d1b260a9e25ed52c33ce2ee8eb.svg";
export { ForwardRef as ReactComponent };